// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2D3Xv","footer":"ModalCreateQualiphyProcedure_footer__i0olU","additionData":"ModalCreateQualiphyProcedure_additionData__lyr0R"};